import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { DialogHeading, DialogList, DialogSection, DialogText } from '../../styles/DialogStyles';

interface Props {
  showFooter?: boolean;
}

function BnplContent({ showFooter = true }: Props) {
  return (
    <div data-testid="bnpl-content">
      <DialogSection>
        <DialogHeading data-testid="bnpl-question-1" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question1.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-1-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question1.answer1')}
        </DialogText>

        <DialogText data-testid="bnpl-question-1-answer-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question1.answer2')}
        </DialogText>

        <DialogList>
          <li>
            <DialogText data-testid="bnpl-question-1-answer-3" size="1" tag="p" type="paragraph">
              {renderContent('littlewoods.dialog.data.bnpl.question1.answer3')}
            </DialogText>
          </li>
          <li>
            <DialogText data-testid="bnpl-question-1-answer-4" size="1" tag="p" type="paragraph">
              {renderContent('littlewoods.dialog.data.bnpl.question1.answer4')}
            </DialogText>
          </li>
        </DialogList>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-2" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question2.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-2-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question2.answer1')}
        </DialogText>

        <DialogText data-testid="bnpl-question-2-answer-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question2.answer2')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-3" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question3.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-3-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question3.answer1')}
        </DialogText>

        <DialogText data-testid="bnpl-question-3-answer-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question3.answer2')}
        </DialogText>

        <DialogText data-testid="bnpl-question-3-answer-3" size="1" tag="p" type="paragraph">
          <strong>{renderContent('littlewoods.dialog.data.bnpl.question3.answer3')}</strong>
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-4" tag="h2" size="1" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question4.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-4-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question4.answer1')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-5" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question5.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-5-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question5.answer1')}
        </DialogText>

        <DialogText data-testid="bnpl-question-5-answer-2" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question5.answer2')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-6" size="1" tag="h2" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question6.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-6-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question6.answer1')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-7" tag="h2" size="1" type="heading">
          {renderContent('littlewoods.dialog.data.bnpl.question7.question')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-7-answer-1" size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.dialog.data.bnpl.question7.answer1')}
        </DialogText>

        {showFooter && (
          <DialogText data-testid="bnpl-dialog-footer" size="1" tag="p" type="paragraph">
            {renderContent('littlewoods.dialog.data.footer')}
          </DialogText>
        )}
      </DialogSection>
    </div>
  );
}

export default BnplContent;
